// test1591
(1591 && 0);
